module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.d7ffc4e2.svg";